import React from 'react';
import { FiSave, FiSave as FiSaveAs, FiDownload, FiRotateCcw, FiRotateCw, FiRefreshCw, FiUpload, FiLogOut } from 'react-icons/fi';

export default function Header({
  handleOpenFromDrive,
  isLoading,
  googleApiReady,
  handleFilePickerClick,
  handleSave,
  svgContent,
  handleSaveAs,
  handleExport,
  historyIndex,
  history,
  handleUndo,
  handleRedo,
  originalSvg,
  fileInputRef,
  handleFileUpload,
  handleReset,
  isSignedIn,
  handleSignOut
}) {
  return (
    <header>
      <div className="header-grid">
        <div className="header-title-row">
          <img src="/assets/vector-tuner-plain.svg" alt="Vector Tuner Logo" style={{ height: 40, marginRight: '1rem', verticalAlign: 'middle' }} />
          <h1>Vector Tuner</h1>
        </div>
        <div className="header-toolbar-row">
          <div className="save-controls">
            <button
              onClick={handleOpenFromDrive}
              disabled={isLoading}
              className="save-button google-drive-button"
              title="Open file from Google Drive"
            >
              <img src="/assets/google-drive-icon.png" alt="Google Drive" style={{ width: 20, height: 20, marginRight: 4, verticalAlign: 'middle', objectFit: 'contain', borderRadius: 4 }} />
              <span>Open file from Google Drive</span>
            </button>
            <button
              onClick={handleFilePickerClick}
              className="save-button upload-button"
              title="Upload SVG file from your computer"
            >
              <FiUpload size={20} />
              <span>Upload File</span>
            </button>
            <button 
              onClick={handleSave} 
              disabled={isLoading || !svgContent}
              className="save-button"
              title="Save or Export"
            >
              <FiSave size={20} />
              <span>Save / Export</span>
            </button>
            <button
              onClick={handleUndo}
              disabled={historyIndex <= 0}
              className="save-button"
              title="Undo"
            >
              <FiRotateCcw size={20} />
              <span>Undo</span>
            </button>
            <button
              onClick={handleRedo}
              disabled={historyIndex >= history.length - 1}
              className="save-button"
              title="Redo"
            >
              <FiRotateCw size={20} />
              <span>Redo</span>
            </button>
            <button
              onClick={handleReset}
              disabled={!originalSvg}
              className="save-button reset-toolbar-button"
              title="Reset to file's initial state"
            >
              <FiRefreshCw size={20} />
              <span>Reset</span>
            </button>
            <button
              onClick={handleSignOut}
              disabled={!isSignedIn}
              className="save-button signout-toolbar-button"
              title="Sign out of Google Drive"
            >
              <FiLogOut size={20} />
              <span>Sign Out</span>
            </button>
          </div>
        </div>
        <div className="header-filepicker-row">
          <input
            type="file"
            accept=".svg"
            onChange={handleFileUpload}
            className="file-input-hidden"
            ref={fileInputRef}
            style={{ display: 'none' }}
          />
        </div>
      </div>
    </header>
  );
} 